<template>
    <div class="scaling">
        <div class="scale" v-for="scale in scaleOptions"
             :class="{'active': isSelectedScale(scale)}"
             :key="scale.getId()"
        >
            <input type="radio" :name="uniqid('scale')"
                   :value="scale.getName()"
                   :checked="isSelectedScale(scale)"
                   @click="scaleSelectedHandler(scale)"
            >
            <span>{{ scale.getName() }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name:     "ScaleSelector",
        props:    {
            'scales':   {
                required: true,
                type:     Array
            },
            'selected': {
                required: true,
                default:  null
            }
        },
        computed: {
            scaleOptions: function () {
                return this.scales.slice().reverse()
            }
        },
        methods:  {
            /**
             * Emits the selected:scale event, when a scale has been clicked
             *
             * @param scale
             */
            scaleSelectedHandler: function (scale) {
                this.$emit('selected:scale', scale)
            },

            /**
             * Checks if the given scale is the currently selected scale
             *
             * @param scale
             * @returns {boolean}
             */
            isSelectedScale: function (scale) {
                if (JSON.parse(JSON.stringify(this.selected)) !== {}) {
                    return this.selected !== null && this.selected.getId() === scale.getId()
                }

                return false
            }
        }
    }
</script>

<style scoped>

</style>
